module.exports = __webpack_public_path__ + "b493bc03c47cfb5b66ffc882e7158336.png";